
import { TableCell, TableRow } from "@/components/ui/table";
import { ProviderWithUser } from "@/types/strategy-types";
import ProviderActions from "./ProviderActions";

interface ProviderTableRowProps {
  provider: ProviderWithUser;
  onEdit: (provider: ProviderWithUser) => void;
  onDelete: (providerId: string) => void;
  onToggleActive: (providerId: string, isActive: boolean) => void;
  onAssignUser: (providerId: string) => void;
  onRemoveUser: (providerId: string, userId: string) => void;
}

const ProviderTableRow = ({
  provider,
  onEdit,
  onDelete,
  onToggleActive,
  onAssignUser,
  onRemoveUser
}: ProviderTableRowProps) => {
  return (
    <TableRow key={provider.id} className={!provider.active ? 'opacity-50' : ''}>
      <TableCell className="font-medium">{provider.name}</TableCell>
      <TableCell>
        {provider.user ? (
          <div className="flex flex-col">
            <span>{provider.user.email}</span>
            <span className="text-xs text-gray-500">
              {provider.user.first_name} {provider.user.last_name}
            </span>
          </div>
        ) : (
          <span className="text-gray-400 italic">No user assigned</span>
        )}
      </TableCell>
      <TableCell>
        {provider.url ? (
          <a 
            href={provider.url} 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            {provider.url}
          </a>
        ) : (
          'N/A'
        )}
      </TableCell>
      <TableCell>
        <span className={provider.active ? 'text-green-500' : 'text-red-500'}>
          {provider.active ? 'Active' : 'Inactive'}
        </span>
      </TableCell>
      <TableCell>
        {new Date(provider.created_at || '').toLocaleDateString()}
      </TableCell>
      <TableCell className="text-right">
        <ProviderActions
          provider={provider}
          onEdit={onEdit}
          onDelete={onDelete}
          onToggleActive={onToggleActive}
          onAssignUser={onAssignUser}
          onRemoveUser={onRemoveUser}
        />
      </TableCell>
    </TableRow>
  );
};

export default ProviderTableRow;
